// Reglas de correo de cada persona: "si el remitente o el asunto contiene X, archivar o destacar". Reemplazan las
// limpiezas automaticas de Zammad (avisos de 3CX, rebotes, recordatorios). Se aplican al mostrar: un hilo que la
// persona ya toco (leyo, destaco o archivo a mano) conserva lo que ella eligio.
import { useSyncExternalStore } from 'react';

import type { EstadoHilo } from './correo';
import { normalize } from './format';
import { readJSON, writeJSON } from './storage';

export type Regla = { id: string; campo: 'remitente' | 'asunto'; contiene: string; accion: 'archivar' | 'destacar' };

type HiloRegla = { id: string; mensajes: { asunto?: string; participantes: { role: string; handle: string; displayName?: string | null }[] }[] };

export function cumple(r: Regla, h: HiloRegla) {
  const buscado = normalize(r.contiene.trim());
  if (!buscado) return false;
  const primero = h.mensajes[0];
  if (!primero) return false;
  if (r.campo === 'asunto') return normalize(primero.asunto ?? '').includes(buscado);
  const de = primero.participantes.find((p) => p.role === 'FROM');
  return normalize(`${de?.handle ?? ''} ${de?.displayName ?? ''}`).includes(buscado);
}

export function aplicarReglas<E extends EstadoHilo>(hilos: HiloRegla[], estados: Map<string, E>, reglas: Regla[]): Map<string, EstadoHilo> {
  if (!reglas.length) return estados;
  const out = new Map<string, EstadoHilo>(estados);
  for (const h of hilos) {
    if (estados.has(h.id)) continue;
    const r = reglas.filter((x) => cumple(x, h));
    if (!r.length) continue;
    out.set(h.id, { leidoEn: null, archivado: r.some((x) => x.accion === 'archivar'), destacado: r.some((x) => x.accion === 'destacar') });
  }
  return out;
}

/* ---------------- guardado (por persona, en este navegador) ---------------- */

const CLAVE = 'consola.reglasCorreo';
let lista: Regla[] = readJSON<Regla[]>(CLAVE, []);
const oyentes = new Set<() => void>();

export function guardarReglas(r: Regla[]) {
  lista = r.filter((x) => x.contiene.trim());
  writeJSON(CLAVE, lista);
  oyentes.forEach((f) => f());
}

export const useReglas = () =>
  useSyncExternalStore(
    (f) => (oyentes.add(f), () => oyentes.delete(f)),
    () => lista,
  );
